import React, { Children, useEffect, useState } from "react";
import TabButton from "../tabButton/TabButton";
import classes from "./TabMenu.module.css";

const TabMenu = ({ children, activeTabKey, onTabChange }) => {

    const childrenArray = Children.toArray(children);
    const defaultTabKey = childrenArray[0]?.props?.tabKey;
    const [activeKey, setActiveKey] = useState(activeTabKey ?? defaultTabKey);

    useEffect(() => {
        if (activeTabKey !== undefined) {
            setActiveKey(activeTabKey);
        }
    }, [activeTabKey]);

    const activeChild = childrenArray.find(
        (child) => String(child.props.tabKey) === String(activeKey)
    );

    const handleTabClick = (key) => {
        setActiveKey(key);
        onTabChange?.(key);

    };

    return (

        <div className={classes.TabMenu}>
            <div className={classes.Tabs}>
                {childrenArray.map((child) => (
                    <TabButton
                        icon={child.props.icon}
                        key={child.props.tabKey}
                        label={child.props.label}
                        isActive={String(child.props.tabKey) === String(activeKey)}
                        onClick={() => handleTabClick(child.props.tabKey)}
                    />
                ))}
            </div>
            {activeChild && (
                <div className={classes.TabContent}>
                    {activeChild}
                </div>
            )}
        </div>
    );
};



export default TabMenu;

export const Tab = ({ children }) => children;

